// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insurance-modal-content {
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  white-space: normal;
}

.close-dogovor {
  background: none;
  border: none;
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  padding: 0;
}

.info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.line {
  display: flex;
  width: 100%;
}

.line-label {
  width: 160px;
  font-size: 14px;
}

.value {
  font-size: 14px;
  font-weight: 400;
}

.calc-link.partner {
  margin: 0;
  font-size: 16px;
}

.value ul {
  margin: 0;
  padding-left: 20px;
}

.modal-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.modal-text {
  text-align: center;
}

@media screen and (max-width: 768px) {
  .line-label {
    width: 130px;
  }
}

.modal-buttons .outlined-button:hover {
  background-color: transparent;
  border-color: #002E19;
  color: #002E19;
}`, "",{"version":3,"sources":["webpack://./src/components/shared/modals/insurances/insuranceModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".insurance-modal-content {\n  width: fit-content;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  white-space: normal;\n}\n\n.close-dogovor {\n  background: none;\n  border: none;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: center;\n}\n\n.line {\n  display: flex;\n  width: 100%;\n}\n\n.line-label {\n  width: 160px;\n  font-size: 14px;\n}\n\n.value {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.calc-link.partner {\n  margin: 0;\n  font-size: 16px;\n}\n\n.value ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.modal-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.modal-text {\n  text-align: center;\n}\n\n@media screen and (max-width: 768px) {\n  .line-label {\n    width: 130px;\n  }\n}\n\n.modal-buttons .outlined-button:hover {\n  background-color: transparent;\n  border-color: #002E19;\n  color: #002E19;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
